(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured_Product"] && !Shopify.designMode) return;
  try {
    
/* drawer-cart logic (unchanged) */
(() => {
  const $sec = document.querySelector('#ProductDetails-{{ section.id }}');
  if(!$sec) return;

  $sec.addEventListener('submit', async e=>{
    const form = e.target.closest('form[action^="/cart/add"]'); if(!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]'), txt = btn.innerHTML;
    btn.disabled = true; btn.innerHTML = "{{ 'products.product.add_to_cart' | t }}…";
    try{
      await fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/x-www-form-urlencoded'},
        body:new URLSearchParams(new FormData(form))
      });
      document.dispatchEvent(new CustomEvent('theme:cart:open'));
    }finally{
      btn.disabled = false; btn.innerHTML = txt;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-compare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-compare')) {
    // Values slide sideways: out with an accelerating curve (stays readable until it leaves), in with a soft landing
    const SLIDE_PX = 16;
    const EASE_EXIT = 'cubic-bezier(0.32, 0, 0.67, 0)';
    const EASE_ENTER = 'cubic-bezier(0.23, 1, 0.32, 1)';

    class HeroCompare extends HTMLElement {
      connectedCallback() {
        const data = this.querySelector('[data-items]');
        this.items = data ? JSON.parse(data.textContent) : [];
        this.dots = [...this.querySelectorAll('[data-dots] button')];
        if (this.items.length < 2) return;

        this.index = 0;
        this.autoplay = this.dataset.autoplay === 'true';
        this.delay = (Number(this.dataset.speed) || 4) * 1000;
        this.announcer = this.querySelector('[data-announce]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        // Arrows step by data-step, dots jump to their own index
        this.onNav = (event) => {
          const button = event.target.closest('button');
          if (!button) return;
          const count = this.items.length;
          const step = Number(button.dataset.step || 0);
          const i = step ? (this.index + step + count) % count : this.dots.indexOf(button);
          if (i < 0 || i === this.index) return;
          this.show(i, step || Math.sign(i - this.index));
          this.announce();
          this.start();
        };
        this.onPause = () => {
          this.paused = true;
          this.stop();
        };
        this.onResume = (event) => {
          if (event.type === 'focusout' && this.contains(event.relatedTarget)) return;
          this.paused = false;
          this.start();
        };

        this.querySelector('[data-nav]').addEventListener('click', this.onNav);
        this.addEventListener('pointerenter', this.onPause);
        this.addEventListener('pointerleave', this.onResume);
        this.addEventListener('focusin', this.onPause);
        this.addEventListener('focusout', this.onResume);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      start() {
        this.stop();
        if (!this.autoplay || this.paused || this.reduceMotion.matches) return;
        this.timer = setInterval(() => this.show((this.index + 1) % this.items.length, 1), this.delay);
      }

      stop() {
        clearInterval(this.timer);
      }

      // dir 1 = next (values move left), -1 = previous (values move right)
      show(i, dir) {
        this.index = i;
        const item = this.items[i];
        const q = (selector) => this.querySelector(selector);

        this.dots.forEach((dot, k) => dot.setAttribute('aria-current', String(k === i)));
        q('[data-link]').href = item.url;
        q('[data-save]').hidden = item.save == null;

        [
          [q('[data-retail]'), `${item.retail}.`],
          [q('[data-price]'), `${item.price}.`],
          [q('[data-insp]'), item.insp ? `Inspired by ${item.insp}` : ''],
          [q('[data-name]'), item.name],
          [q('[data-retail-card]'), item.retail],
          [q('[data-price-card]'), item.price],
          [q('[data-save]'), `Save ${item.save}%`],
          [q('[data-link]'), `Shop ${item.name}`],
        ].forEach(([el, text]) => this.slide(el, text, dir));
      }

      // Old value slides out one way, new value slides in from the other side. transform + opacity only.
      slide(el, text, dir) {
        const running = el.getAnimations();
        running.forEach((animation) => animation.cancel());
        // Unchanged values slide too, so the whole card always moves together
        if (this.reduceMotion.matches) {
          el.textContent = text;
          return;
        }

        const enter = () => {
          el.getAnimations().forEach((animation) => animation.cancel());
          el.textContent = text;
          el.animate(
            [
              { opacity: 0, transform: `translateX(${SLIDE_PX * dir}px)` },
              { opacity: 1, transform: 'translateX(0)' },
            ],
            { duration: 360, easing: EASE_ENTER }
          );
        };
        // Clicked again mid-slide: skip the exit so fast clicking never queues up
        if (running.length) return enter();

        el.animate(
          [
            { opacity: 1, transform: 'translateX(0)' },
            { opacity: 0, transform: `translateX(${-SLIDE_PX * dir}px)` },
          ],
          { duration: 180, easing: EASE_EXIT, fill: 'forwards' }
        ).finished.then(enter, () => {});
      }

      // One polite announcement per manual change
      announce() {
        const item = this.items[this.index];
        const label = (selector) => this.querySelector(selector)?.textContent.trim();
        this.announcer.textContent = `${item.name}: ${label('.hero-compare__row--them span')} ${item.retail}, ${label('.hero-compare__row--us span')} ${item.price}`;
      }
    }

    customElements.define('hero-compare', HeroCompare);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-tabs')) {
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.viewAll = this.querySelector('[data-view-all]');
        this.onClick = (event) => {
          const tab = event.target.closest('[role="tab"]');
          if (tab) this.select(tab);
        };
        this.onKeydown = (event) => {
          const i = this.tabs.indexOf(event.target);
          if (i < 0) return;
          const last = this.tabs.length - 1;
          const next = {ArrowRight: i === last ? 0 : i + 1, ArrowLeft: i === 0 ? last : i - 1, Home: 0, End: last}[event.key];
          if (next === undefined) return;
          event.preventDefault();
          this.select(this.tabs[next]);
          this.tabs[next].focus();
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
      }

      select(tab) {
        this.tabs.forEach((t) => {
          const active = t === tab;
          t.setAttribute('aria-selected', String(active));
          t.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
        if (this.viewAll) this.viewAll.href = tab.dataset.url;
        tab.scrollIntoView({block: 'nearest', inline: 'nearest'});
      }
    }

    customElements.define('product-tabs', ProductTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
